import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CustomerService } from "./customer.service";
import { CustomerClient, ContactWeb, UtilityClient } from "../models";
import { ErrorDialogComponent } from "../components/error-dialog/error-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { filter, tap } from "rxjs/operators";
import { SessionDataService } from "./session-data.service";



@Injectable({
    providedIn: "root",
})
export class ContactService
{

    private contactsSubject: BehaviorSubject<ContactWeb[]> = new BehaviorSubject<ContactWeb[]>([]);
    public contacts: Observable<ContactWeb[]> = this.contactsSubject.asObservable();
    public contactsList: ContactWeb[];
    private branchCustId: string;
    private isEmployee: boolean;

    constructor(
        private utilityClient: UtilityClient,
        private customerClient: CustomerClient,
        private sessionDataService: SessionDataService,
        private customerService: CustomerService,
        private dialog: MatDialog,
    )
    {
        this.customerService.customer
            .pipe(filter(customer => !!customer))
            .subscribe(customer =>
            {
                this.branchCustId = customer.BranchCustId;
                this.populateContacts();
            });

        this.isEmployee = this.sessionDataService.IsEmployee;
    }

    private populateContacts(): void
    {
        this.customerClient.getWebContacts(this.branchCustId).subscribe(c => 
        {
            this.contactsList = c;
            this.contactsSubject.next(c);
        });
    }

    public getContacts(): Array<ContactWeb>
    {
        return this.contactsSubject.value;
    }

    public checkEmails(): boolean
    {
        if (this.contactsList != null)
            return (!this.contactsList.some(c => c.Email) && !this.isEmployee);
    }

    public updateContact(contact: ContactWeb): Observable<boolean>
    {

        if (contact.Key == null || contact.Key.length < 6)
        {
            contact.Key = this.branchCustId;
        }
        return this.utilityClient.writeContactWeb(contact)
            .pipe(tap(_ =>
            {
                this.populateContacts();
            }));
    }

    public deleteContact(contact: ContactWeb): void
    {
        this.utilityClient.deleteContactWeb(contact).subscribe(c =>
        {
            this.populateContacts();
        },
            (error =>
            {
                console.log("Error deleting the contact. " + error);
                const errorMessage: string = "Your contact was not deleted. Please try again.";

                this.dialog.open(ErrorDialogComponent, {
                    minWidth: "360px",
                    data: errorMessage,
                });
            }));
    }
}
